import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import styles from './styles'

const VisaRequirementDetail = ({ label, requirements }) => {
  if (!requirements || requirements.length === 0) {
    return null
  }

  return (
    <p className={styles.visaRequirementDetail}>
      {label}
      <For each="requirement" of={requirements} index="index">
        <Choose>
          <When condition={requirements.length === 1}>
            <Fragment key={requirement}> {requirement}</Fragment>
          </When>
          <When condition={requirements.length === 2}>
            <Choose>
              <When condition={index === requirements.length - 1}>
                <Fragment key={requirement}> or {requirement}</Fragment>
              </When>
              <Otherwise>
                <Fragment key={requirement}> {requirement}</Fragment>
              </Otherwise>
            </Choose>
          </When>
          <Otherwise>
            <Choose>
              <When condition={index === requirements.length - 1}>
                <Fragment key={requirement}> or {requirement}</Fragment>
              </When>
              <Otherwise>
                <Fragment key={requirement}> {requirement},</Fragment>
              </Otherwise>
            </Choose>
          </Otherwise>
        </Choose>
      </For>
    </p>
  )
}

VisaRequirementDetail.propTypes = {
  label: PropTypes.string,
  requirements: PropTypes.arrayOf(PropTypes.string),
}

export default VisaRequirementDetail
